<template>
	<div class="headerbar">
		<div class="header">
			<a href="javascript:;" class="header-logo"><img src="../../assets/base/logo.png" alt=""></a>
			<div class="header-cont">
				<ul class="header-nav">
					<!-- :class="{active:$route.name === item.entity.text}" -->
					<li v-for="(item, index) in items" :key="item.entity.id" :class="$route.name === item.entity.en?'active':''"  @mouseenter="showDropDownMenu(index)" @mouseleave="hideDropDownMenu">
						<router-link :to="item.entity.url" class="levelo">{{item.entity.text}}</router-link>
						<transition name="fade">
							<div class="header-nav-level" v-if="seen&&index==current">
								<router-link v-for="(el, _index) in item.childs" :key="el.id" :to="el.url" :class="{on:$route.name === el.text}" @click="cancleSeen()">{{el.text}}</router-link>
							</div>  
						</transition>
					</li>
				</ul>
				<span class="header-line"></span>
				<!-- <a href="#" class="gardenlogin">园所登陆</a> -->
			</div>
			<!-- <span class="header-tel"><img src="../../assets/base/header_tel.png" alt=""></span> -->
		</div>
	</div>
</template>
<script>
	export default {
	  name: 'Header',
	  data () {
		  return {
			seen: false,
			flag: -1,
			current: 0,
			num: -1,
			items: [
				{
					entity: {id: 1, text: '首页', en: 'index', url: '/'}
				},
				{
					entity: {id: 2, text: '互联网产品',en: 'pomelo', url: '/pomelo'},
					childs: [
						{id: 20, text: '园所端', url: '/kindergarten'},
						{id: 21, text: '教师端', url: '/teacher'},
						{id: 22, text: '家长端', url: '/parents'}
					]
				},
				{
					entity: {id: 3, text: '幼教合伙人',en: 'partner', url: '/partner'}
				},
				{
					entity: {id: 4, text: '特色课程',en: 'course', url: '/course'}
				},
				{
					entity: {id: 5, text: '合作案例',en: 'case', url: '/case'}
				},
				{
					entity: {id: 6, text: '代理合作',en: 'agent', url: '/agent'}
				},
				{
					entity: {id: 7, text: '关于我们',en: 'aboutus', url: '/aboutus'}
				},
				{
					entity: {id: 8, text: '帮助中心',en: 'help', url: '/help'}
				},
				{
					entity: {id: 9, text: '下载APP',en: 'download', url: '/download'}
				}
			],
			
		  }
	  },
	  methods: {
		  showDropDownMenu: function(index) {
			  this.seen = true;
			  this.current = index;
		  },
		  hideDropDownMenu: function() {
			  this.seen = false;
			  this.current = null;
		  }
		  
	  },
// 	  created () {
// 			if(this.$route.name === '新闻资讯' || this.$route.name === '新闻资讯详情') {
// 				this.num = 6
// 			}else{
// 				this.num = -1
// 			}
// 			console.log(this.$route.name)
// 		    console.log(this.num)
// 		  
// 	  }
	}

</script>
<style lang="scss" scoped>
	@import '../../base/scss/mixin.scss';
	.fade-enter-active, .fade-leave-active {
	  transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to {
	  opacity: 0;
	}
	.headerbar {
		width: 100%;
		min-width: 1400px;
		height: 235px;
		//position: fixed;
		position: absolute;
		left: 0;
		top: 0;
		// position: relative;
		z-index: 9999;
		background: url(../../assets/base/headerbar.png) center top no-repeat;
	}
	.header {
		@extend %width;
		@extend %clearfix;
		position: relative;
		padding-top: 34px;
		font-size: 16px;
		&-tel {
			height: 30px;
			line-height: 30px;
			position: absolute;
			right: -180px;
			top: 54px;
			background: url(../../assets/base/tel.png) left center no-repeat;
			padding-left: 45px;
			img {
				vertical-align: middle;
			}
		}
		&-logo {
			float: left;
			width: 208px;
			margin-left: 16px;
			img {
				width: 100%;
			}
		}
		&-cont {
			position: relative;
			margin-left: 208px + 86px;
			margin-right: 12px;
			text-align: right;
			a {
				color: #fff;
			}
		}
		&-nav {
			height: 64px - 22px - 25px;
			padding: 22px 0 25px;
			text-align: left;
			li {
				float: left;
				margin: 0 10px;
				height: 24px - 8px;
				position: relative;
				.levelo {
					display: block;
					float: left;
					padding: 0 4px;
					padding-bottom: 4px;
					transition: color .35s;
					position: relative;
					cursor: pointer;
					font-size: 16px;
					color: #fff;
					&::before {
						content: "";
						position: absolute;
						left: 0;
						bottom: -2px;
						width: 100%;
						height: 2px;
						background: #e3b020;
						transition: transform .5s;
						transform: scaleX(0);
						transform-origin: 100% 0;
					}
					&:hover{
						color: #e3b020;
						&::before {
							transform: scaleX(1);
							transform-origin: 0 0;
						}
					}
					
				}
				
			}
			.active {
				.levelo {
					border-bottom: 2px solid #e3b020;
					color: #e3b020;
				}
				
			}
			&-level {
				position: absolute;
				left: 50%;
				top: 22px;
				width: 80px;
				padding: 0 11px;
// 				height: 120px - 14px;
// 				padding-top: 14px;
				margin-left: -51px;
				background: rgba(9,19,56,.72);
				a {
					display: block;
					padding-bottom: 8px;
					margin-top: 12px;
					margin-bottom: 10px;
					border-bottom: 2px solid  transparent;
					text-align: center;
					font-size: 16px;
					transition: all ease-out .35s;
					&:hover {
						color: #e3b020;
						border-bottom-color: #e3b020;
					}
				}
				.on {
					color: #e3b020;
					border-bottom-color: #e3b020;	
				}
			}
		}
	// 	&-line {
	// 		width: 74px;
	// 		height: 3px;
	// 		background: #e3b020;
	// 		position: absolute;
	// 		left: -7px;
	// 		top: 46px;
	// 	}
		.gardenlogin {
			display: inline-block;
			width: 112px - 20px;
			@include lh(30px);
			padding-left: 20px;
			background: url(../../assets/base/garden_login_icon.png) 10px center no-repeat #f9981b;
			border-radius: 4px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/Header.vue